
import {
    GET_DIS_PROFIT,
    GET_HISTORY,
    GET_HISTORY2,
    GET_HISTORY3, GET_HISTORY_ALL_SELL, GET_LIMIT_ORDERS,
    GET_PROFIT_COUNT,
    GET_TOTAL_COUNT,
    TRANS_LOG,
    TRANS_LOG2
} from "./queryParams";
import {getData, getDataSimple, makeSearchParams} from "./queryBase";
import {Underling} from "../config/const";
import {BigNumber} from "ethers";
import {transBig2number} from "../utils/functions";
import {getAccount, getChainId} from "../utils/wallet";
import config from "../config/config";

export async function getQueryUrl(){
    let chainId=await getChainId();
    return config[chainId].queryUrl;
}

export async function getHistoryData(taker,page,start=0,end=0){
    let queryParams =  GET_HISTORY.replace("$taker",taker.toLowerCase());
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    if(end==0){
        end=parseInt(new Date().getTime()/1000)
    }
    let historyData=await getData(queryUrl,queryData,page,"timestamp","desc",start,end);
    return historyData;
}

export async function getHistoryDataAllSell(traders){
    let queryParams =  GET_HISTORY_ALL_SELL.replace("$allTakers","\""+traders.join("\",\"")+"\"");
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    let historyData=await getData(queryUrl,queryData,0,"timestamp","desc",0,0);
    return historyData;
}

export async function getDisProfit(contract){
    let queryParams =  GET_DIS_PROFIT.replace("$contract",contract);
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    let profitData=await getData(queryUrl,queryData,0,"time","desc",0,0);
    return profitData;
}

export async function getTransData(user,trader,page){
    let queryParams="";
    if(!user){
        queryParams =  TRANS_LOG2;
    }else{
        queryParams =  TRANS_LOG.replace("$user",user.toLowerCase());
    }
    // let queryParams =  TRANS_LOG.replace("$user","0x268d5b0816e406a4591fb4498787c576d0244eb4");
    queryParams =  queryParams.replace("$trader",trader.toLowerCase());
    // queryParams =  queryParams.replace("$trader","0x43031683563ba34aebb01cd9c0df00854d78208e");
    // let queryParams =  TRANS_LOG2.replace("$trader",trader);
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    let historyData=await getData(queryUrl,queryData,page);
    return historyData;
}

export async function getOrderCountInfo(trader){
    let queryUrl=await getQueryUrl()
    let queryTotalAll= GET_TOTAL_COUNT.replace("$taker",trader.toLowerCase())
    let queryData=makeSearchParams(queryTotalAll);
    let total=await getDataSimple(queryUrl,queryData)

    let queryProfit=GET_PROFIT_COUNT.replace("$taker",trader.toLowerCase())
    let queryProfitData=makeSearchParams(queryProfit)
    let profit=await getDataSimple(queryUrl,queryProfitData)


    return [total.orders.totalCount,profit.orders.totalCount]
}

export async function getAssetInfo(contract,days){
    let startTime=Math.ceil(new Date()/1000)-86400*days;
    let endTime=Math.ceil(new Date()/1000);
    let taker=contract;
    let queryParams =  GET_HISTORY.replace("$taker",taker.toLowerCase());
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    // startTime=1;

    let allData=await getData(queryUrl,queryData,0,"timestamp","",startTime,endTime);

    let ethAmount=BigNumber.from(0);
    let btcAmount=BigNumber.from(0);
    for(let i in allData.orderHistories){
        let item=allData.orderHistories[i];
        if(item.name===Underling.BTC){
            btcAmount=btcAmount.add(BigNumber.from(item.amount));
        }else if(item.name===Underling.ETH){
            ethAmount=ethAmount.add(BigNumber.from(item.amount));
        }
    }

    return [transBig2number(btcAmount),transBig2number(ethAmount)];
}

export async function getHistoryLimitOrder(taker,page,start=0,end=0){
    let queryParams =  GET_LIMIT_ORDERS.replace("$taker",taker.toLowerCase());
    let queryData=makeSearchParams(queryParams);
    let queryUrl=await getQueryUrl()
    if(end==0){
        end=parseInt(new Date().getTime()/1000)
    }
    let historyData=await getData(queryUrl,queryData,page,"timestamp","desc",start,end);
    return historyData;
}




